import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export function sendTournamentInvite(
  user: AppUser,
  tournamentId: string,
  data: {
    invitedSchoolId: string;
    message?: string;
    inviteSource?: 'MANUAL_UNION_INVITE' | 'ONLINE_BOOKING';
  },
  inviterSchoolId?: string
) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  const schoolId = typeof inviterSchoolId !== 'undefined' ? inviterSchoolId : activeSchoolId;

  return axios
    .post(`${window.apiBase}/i/schools/${schoolId}/tournaments/${tournamentId}/invites`, data, config)
    .then(response => {
      return response.data;
    });
}
